import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module'
import { NgxMasonryModule } from 'ngx-masonry';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome'
import { LazyLoadImageModule } from 'ng-lazyload-image'

import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp';
import { faFacebookMessenger } from '@fortawesome/free-brands-svg-icons/faFacebookMessenger';
import { faTelegramPlane } from '@fortawesome/free-brands-svg-icons/faTelegramPlane';
import { faLine } from '@fortawesome/free-brands-svg-icons/faLine';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';

import { BlogRoutingModule } from './blog-routing.module';
import { BlogComponent } from './blog.component';
import { SidebarComponent } from './widgets/sidebar/sidebar.component';

import { ColumnLeftSidebarComponent } from './blog-grid/column-left-sidebar/column-left-sidebar.component';

import { DetailGalleryComponent } from './blog-detail/detail-gallery/detail-gallery.component';
import { DetailVideoComponent } from './blog-detail/detail-video/detail-video.component';
import { DetailLeftSidebarComponent } from './blog-detail/detail-left-sidebar/detail-left-sidebar.component';
import { MasonryGalleryModule } from 'ngx-masonry-gallery';
import { BlogFilterPipe } from '../pipes/blog-filter.pipe';

@NgModule({
  declarations: [
    BlogComponent,
    SidebarComponent,
    ColumnLeftSidebarComponent,
    DetailGalleryComponent,
    DetailVideoComponent,
    DetailLeftSidebarComponent,
    BlogFilterPipe,
  ],
  imports: [
    CommonModule,
    BlogRoutingModule,
    SharedModule,
    NgxMasonryModule,
    CarouselModule,
    NgbModule,
    MasonryGalleryModule,
    TranslateModule,
    ShareButtonsModule,
    FontAwesomeModule,
    LazyLoadImageModule,
  ],
})
export class BlogModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(...[faFacebookF, faWhatsapp, faTelegramPlane, faLine, faLink, faCheck])
  }
}
